import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  styled
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';

const SuccessIcon = styled(CheckCircleIcon)(({ theme }) => ({
  fontSize: 64,
  color: '#4CAF50',
  marginBottom: '16px'
}));

const Title = styled(Typography)(({ theme }) => ({
  color: '#212B36',
  fontSize: '20px',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: '8px',
  fontFamily: "'Inter', sans-serif"
}));

const Description = styled(Typography)(({ theme }) => ({
  color: '#637381',
  fontSize: '14px',
  textAlign: 'center',
  marginBottom: '24px',
  fontFamily: "'Inter', sans-serif"
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  padding: '10px 20px',
  textTransform: 'none',
  fontFamily: "'Inter', sans-serif",
  fontSize: '14px',
  fontWeight: 600,
  minWidth: '180px'
}));

const ProposalSuccessDialog = ({ open, onClose, proposalId }) => {
  const navigate = useNavigate();

  const handleViewProposals = () => {
    navigate('/proposals');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '24px'
        }
      }}
    >
      <DialogContent>
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          textAlign: 'center'
        }}>
          <SuccessIcon />
          
          <Title>
            Proposal Created Successfully!
          </Title>
          
          <Description>
            Your loan proposal has been created and sent to the borrower. You can track its status in the proposals section.
          </Description>
          
          <Box sx={{ 
            display: 'flex', 
            gap: 2,
            flexDirection: { xs: 'column', sm: 'row' }
          }}>
            <ActionButton
              variant="outlined"
              onClick={onClose}
              sx={{
                color: '#637381',
                borderColor: '#C4CDD5',
                '&:hover': {
                  borderColor: '#919EAB',
                  backgroundColor: 'rgba(145, 158, 171, 0.08)'
                }
              }}
            >
              Close
            </ActionButton>
            
            <ActionButton
              variant="contained"
              onClick={handleViewProposals}
              sx={{
                backgroundColor: '#0052CC',
                '&:hover': {
                  backgroundColor: '#003E99'
                }
              }}
            >
              View All Loans
            </ActionButton>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ProposalSuccessDialog; 